module.exports = __webpack_public_path__ + "img/115.8572f881.jpg";